import { attr, belongsTo, hasMany } from 'spraypaint'
import ApplicationRecord from './ApplicationRecord'
import placeholder from '../assets/placeholder_elementary.png'

const StudentImage = ApplicationRecord.extend({
  static: {
    jsonapiType: 'student_images',
  },
  attrs: {
    grade: attr(),
    year: attr(),
    folder: attr(),
    needsRetake: attr(),
    accesscode: attr(),
    studentId: attr(),
    packageId: attr(),
    multiSeasonPackageId: attr(),
    // Is this access code from a PREVIOUS year, and (seniors only) which senior
    // pricelist to send them to instead. Both decided server-side against
    // SeasonCalendar -- see StudentImage#past_season?.
    pastSeason: attr(),
    seniorPastPackageId: attr(),
    // THIS YEAR'S pricelist for this photo's kind of picture -- what the
    // past-images screens' "View Packages" opens, so an old photograph is
    // bought at today's prices. An extra_attribute: only populated when asked
    // for with selectExtra(['currentTypePackageId']). Null means the school
    // sells nothing of this kind, and the link is not shown.
    currentTypePackageId: attr(),
    // Was this player only ever in the team picture, and which pose is it?
    // extra_attributes -- only populated when asked for with
    // selectExtra(['sportTeamPhotoOnly', 'sportTeamPoseIds']). The slot-number
    // rule behind them lives in Pose.team_photo_only?; nothing here re-derives
    // it from a pose number.
    sportTeamPhotoOnly: attr(),
    sportTeamPoseId: attr(),
    // Every team picture, lowest slot first (cross country: boys, girls, co-ed).
    sportTeamPoseIds: attr(),
    // Team and/or buddy pictures, no portrait, and every such picture (team
    // first) -- StudentImage#sport_group_poses. Supersede the two above.
    sportGroupPhotoOnly: attr(),
    sportGroupPoseIds: attr(),
    createdAt: attr(),
    updatedAt: attr(),
    imageUrl: attr(),
    ignoreBaseScope: attr(),
    newSeasonNotAvailable: attr(),
    watermarkUrl: attr(),
    student: belongsTo(),
    package: belongsTo({ persist: false }),
    orderPackages: hasMany(),
    seniorImages: hasMany(),
    poses: hasMany(),
    sharedPoses: hasMany(),
    siblingImages: attr(),
  },
  methods: {
    format() {
      const parts = this.imageUrl.split('.')

      return parts[parts.length - 1].toUpperCase()
    },
    isJPG() {
      const parts = this.imageUrl.split('.').map(part => part.toUpperCase());

      return parts.some((part) => ['JPG', 'JPEG'].includes(part.toUpperCase()));
    },
    isPNG() {
      const parts = this.imageUrl.split('.').map(part => part.toUpperCase())

      return parts.some((part) => part.toUpperCase().includes('PNG'))
    },
    image() {
      if (this.watermarkUrl) return this.watermarkUrl

      return placeholder
    },
    watermark() {
      if (this.watermarkUrl) return this.watermarkUrl

      return placeholder
    },
  },
})

export default StudentImage
